import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown, DropdownChangeParams } from "primereact/dropdown";
import React, { useState } from "react";
import useDashboardStore from "store/dashboard-store";

interface MoveGroupComponentProps {
  isMoveComponentVisible: boolean;
  setIsMoveComponentVisible: (isMoveComponentVisible: boolean) => void;
  tabId: number;
  groupId: string;
  componentId: string;
}

const MoveGroupComponent = (props: MoveGroupComponentProps) => {
  const [selectedGroup, setSelectedGroup] = useState<number>(0);
  const moveComponent = useDashboardStore(state => state.moveComponent);
  const [selectedDashboardTabId, setSelectedDashboardTabId] = useState<number | null>(null);
  const dashboard = useDashboardStore(state => state.dashboard)

  const tabOptions =
  dashboard?.dashboardTabsJs.map((tab, index) => ({
      label: tab.title,
      value: index,
    })) || [];

  const groupOptions = dashboard?.dashboardTabsJs.find(
    (tab, index) => index === selectedDashboardTabId
  )?.componentGroups;

  const handleTabChange = (e: DropdownChangeParams) => {
    setSelectedDashboardTabId(e.value);
  };

  const handleMoveToGroup = () => {
    if (selectedGroup && selectedDashboardTabId !== null) {
      moveComponent(
        props.groupId,
        props.componentId,
        selectedGroup,
        props.tabId,
        selectedDashboardTabId
      );
      props.setIsMoveComponentVisible(false);
    }
  };  

  return (
    <Dialog
      header="Move component"
      visible={props.isMoveComponentVisible}
      onHide={() => props.setIsMoveComponentVisible(false)}
      draggable={false}
      blockScroll
      footer={
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={() => props.setIsMoveComponentVisible(false)}
          />
          <Button
            label="Move"
            icon="pi pi-check"
            onClick={handleMoveToGroup}
            disabled={!selectedGroup}
          />
        </div>
      }
    >
      <div className="flex flex-column gap-3">
        <div className="flex flex-column">
          <label htmlFor="tab">Select tab</label>
          <Dropdown
            id="tab"
            value={selectedDashboardTabId}
            options={tabOptions}
            filter
            onChange={handleTabChange}
            optionLabel="label"
            optionValue="value"
            placeholder="Select a tab"
            disabled={tabOptions.length === 0}
          />
        </div>
        <div className="flex flex-column">
          <label htmlFor="currentGroups">Select group:</label>
          <Dropdown
            id="currentGroups"
            value={selectedGroup}
            options={groupOptions?.map((group, index) => ({
              label: group.title || `Group ${index + 1}`,
              value: group.id,
            }))}
            onChange={e => setSelectedGroup(e.value)}
            placeholder="Select a group"
          />
        </div>
      </div>
    </Dialog>
  );
};

export default MoveGroupComponent;
